var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "notification-dialog-template",
    {
      class: _vm.$style.dialog,
      attrs: { theme: _vm.styles.dialog, icon: _vm.actualIcon },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
      },
    },
    [
      _c("template", { slot: "subTitle" }, [
        _vm._v(" " + _vm._s(_vm.subTitle) + " "),
      ]),
      _c("template", { slot: "title" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _c(
        "template",
        { slot: "message" },
        [_c("rb-safe-html", { attrs: { html: _vm.message } })],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _vm.buttonsConfiguration.type === _vm.buttonType.CONFIRMATION
            ? [
                _c(
                  "v-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.buttonsConfiguration.cancel || "Cancel") +
                        " "
                    ),
                  ]
                ),
                _c(
                  "v-button",
                  {
                    attrs: { type: _vm.styles.button },
                    on: {
                      click: function ($event) {
                        return _vm.hide()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.buttonsConfiguration.confirm || "OK") +
                        " "
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "v-button",
                  {
                    attrs: { type: _vm.styles.button },
                    on: {
                      click: function ($event) {
                        return _vm.hide()
                      },
                    },
                  },
                  [_vm._v(" OK ")]
                ),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }